'use client'

import { createContext, useContext, useEffect } from 'react'

import { useRouter } from '@/shared/i18n'

import { Session } from '../server'

export interface SessionContextValue {
  data: Session | null | undefined
  status: 'loading' | 'authenticated' | 'unauthenticated'
  update: () => Promise<void>
}

export const SessionContext = createContext<SessionContextValue | null>(null)

export const useSession = ({
  required = false,
}: {
  required?: boolean
} = {}) => {
  const router = useRouter()
  const context = useContext(SessionContext)

  if (!context) {
    throw new Error('useSession must be used within a SessionProvider')
  }

  const requiredAndNotLoading = required && context.status === 'unauthenticated'

  useEffect(() => {
    if (requiredAndNotLoading) {
      router.replace('/sign-in')
    }
  }, [requiredAndNotLoading, router])

  if (requiredAndNotLoading) {
    return {
      data: context.data,
      update: context.update,
      status: 'loading',
    }
  }

  return context
}
